import { IDesignerProblemsState, ProductProblems } from './IDesignerProblem';
import { PayloadAction } from '@reduxjs/toolkit';

export function setProductProblemsReducer(
  state: IDesignerProblemsState,
  action: PayloadAction<ProductProblems>,
) {
  state.products = action.payload;
}
